export default `
  mutation deleteCardAttachment($workflowId: String, $id: ID!) {
    deleteCardAttachment(workflowId: $workflowId, id: $id) {
      id
      cardId
      workflowId
    }
  }
`
